//  Client\client-vite\src\components\Footers\PublicFooter.tsx

export const PublicFooter = () => {
    return (
        <div className="">
            <footer className="w-full text-gray-500 border-t  text-center py-4 text-xs">
                © {new Date().getFullYear()} IDSCRM — All rights reserved.
            </footer>

            {/* FOOTER */}
            {/* <footer className="relative z-10 py-8 text-center text-sm text-gray-500 border-t border-white/10">
                <p>© {new Date().getFullYear()} IDSCRM — Integrated Dealer Solutions</p>
            </footer> */}
        </div>
    )
}

export default PublicFooter